export const PRIVU_THEME = "PrivuBase";

export const THEME_MODES = ["light"];

export default { theme: PRIVU_THEME, mode: "light" };
